import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'

import { useFetchBuyerInvoiceQuery, useFetchBuyerLineItemsQuery } from '../api'
import {
  Button,
  Container,
  InvoiceOrders,
  InvoiceSidePanel,
  InvoiceTotals,
  PageTitle,
  PDFPreview,
  Typography,
} from 'src/modules/ui'
import InvoiceBuyerActions from './InvoiceBuyerActions'

const useStyles = makeStyles(theme => ({
  body: {
    backgroundColor: theme.palette.fadedPurple.main,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    [theme.breakpoints.up('desktop')]: {
      flexDirection: 'row',
    },
  },
  content: {
    flexGrow: 1,
  },
  inputRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('tablet')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  buttonLink: {
    textDecoration: 'none',
  },
}))

const ViewInvoice = invoice => {
  const { document, invoiceNumber, orders } = invoice
  const classes = useStyles()
  const [hidePDF, setHidePDF] = useState(false)

  const orderIds = orders.map(({ id }) => id)
  const lineItemsQuery = useFetchBuyerLineItemsQuery(
    { orderId: orderIds },
    {
      refetchOnMountOrArgChange: true,
    }
  )

  if (lineItemsQuery.isLoading) {
    return (
      <Container>
        <Typography>Loading...</Typography>
      </Container>
    )
  }

  const togglePDF = () => {
    setHidePDF(!hidePDF)
  }

  return (
    <Container>
      <PageTitle>View Invoice {invoiceNumber}</PageTitle>
      <div className={classes.body}>
        <div className={classes.content}>
          <div className={classes.inputRow}>
            {document && (
              <>
                {!hidePDF && (
                  <Button color="secondary" size="large" onClick={togglePDF}>
                    Hide PDF
                  </Button>
                )}
                {hidePDF && (
                  <Button color="secondary" size="large" onClick={togglePDF}>
                    Show PDF
                  </Button>
                )}
              </>
            )}
          </div>
          {!hidePDF && <PDFPreview document={document} />}
          <InvoiceOrders orders={orders} lineItems={lineItemsQuery.data} />
          <InvoiceTotals invoice={invoice} />
        </div>
        <InvoiceSidePanel invoice={invoice}>
          <InvoiceBuyerActions invoice={invoice} />
        </InvoiceSidePanel>
      </div>
    </Container>
  )
}

const ViewInvoiceContainer = ({ match }) => {
  const { id } = match.params

  const invoiceQuery = useFetchBuyerInvoiceQuery(id, {
    refetchOnMountOrArgChange: true,
  })

  if (invoiceQuery.isLoading) {
    return (
      <Container>
        <Typography>Loading...</Typography>
      </Container>
    )
  }

  return <ViewInvoice {...invoiceQuery.data} />
}

export default ViewInvoiceContainer
